class BeforeAfter {
  constructor(element, options = {}) {
    console.group('BeforeAfter: Initialization');
    console.log('Target Element:', element);

    const defaults = {
      touch: true,
      message: '<&nbsp&nbsp>',
      hide_message: true,
      reset: true,
      reset_delay: 3000,
    };

    this.container = element;
    this.options = { ...defaults, ...options };
    this.resetTimer = null;

    this.init();
    console.groupEnd();
  }

  init() {
    if (!this.container) {
      return;
    }

    const imgBefore = this.container.querySelector('img');

    if (!imgBefore) {
      return;
    }

    if (this.container.querySelector('.g-img-after')) {
      return;
    }

    const afterSrc = imgBefore.dataset.aftersrc;
    if (!afterSrc) {
      return;
    }

    const width = this.container.offsetWidth;

    // Structure Setup
    const originalImg = imgBefore.cloneNode(true);
    this.container.innerHTML = '';
    this.container.appendChild(originalImg);

    const newImgBefore = this.container.querySelector('img');
    newImgBefore.classList.add('g-img-before');
    newImgBefore.style.width = '100%';
    newImgBefore.style.display = 'block';

    this.afterContainer = document.createElement('div');
    this.afterContainer.className = 'g-img-after';

    Object.assign(this.afterContainer.style, {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '50%',
      height: '100%',
      overflow: 'hidden',
      zIndex: '1',
    });

    this.afterContainer.innerHTML = `
      <img src="${afterSrc}" style="width: ${width}px; max-width: none; height: 100%; object-fit: cover; position: absolute; left: 0; top: 0;">
    `;
    newImgBefore.after(this.afterContainer);

    this.divider = document.createElement('div');
    this.divider.className = 'g-img-divider';
    this.divider.style.left = '50%';
    this.divider.innerHTML = `<span>${this.options.message}</span>`;
    this.container.appendChild(this.divider);
    this.message = this.divider.querySelector('span');

    this.addEventListeners();
  }

  addEventListeners() {
    const moveHandler = (e) => this.onMove(e);

    ['mouseenter', 'touchstart'].forEach((evt) => {
      this.container.addEventListener(evt, () => {
        if (this.resetTimer) {
          clearTimeout(this.resetTimer);
          this.resetTimer = null;
        }
      });
    });

    ['mousemove', 'touchmove'].forEach((evt) => {
      this.container.addEventListener(evt, moveHandler, { passive: false });
    });

    ['mouseleave', 'touchend', 'touchcancel'].forEach((evt) => {
      this.container.addEventListener(evt, () => {
        if (this.options.reset) this.startResetTimer();
      });
    });
  }

  onMove(e) {
    if (e.type === 'touchmove') e.preventDefault();

    const rect = this.container.getBoundingClientRect();
    let pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
    let positionX = pageX - rect.left - window.scrollX;
    let percentage = (positionX / rect.width) * 100;

    percentage = Math.max(0, Math.min(percentage, 100));

    this.updatePosition(percentage);
  }

  updatePosition(pct) {
    this.afterContainer.style.width = `${pct}%`;
    this.divider.style.left = `${pct}%`;
  }

  startResetTimer() {
    this.resetTimer = setTimeout(() => {
      this.afterContainer.style.transition = 'width 0.5s ease';
      this.divider.style.transition = 'left 0.5s ease';
      this.updatePosition(50);

      setTimeout(() => {
        this.afterContainer.style.transition = '';
        this.divider.style.transition = '';
      }, 500);

      this.resetTimer = null;
    }, this.options.reset_delay);
  }
}

// At the very bottom of beforeafter-plugin.js, outside the class:
(function (window) {
  window.initBeforeAfter = function (selector, options) {
    const elements = document.querySelectorAll(selector);
    if (elements.length === 0) {
      return;
    }
    elements.forEach((el) => new BeforeAfter(el, options));
  };
})(window);
